import store from '@/store'
import { getData } from '@core/utils/http/general'
import { ref } from '@vue/composition-api'

//* Method to fill param request from table 'Plan de estudios'
export const configTablePlanes = () => {
  //* This will be our table columns => { key: 'name of the object propiety', label: 'how to show in table' }
  const tableColumns = [
    { key: 'id', sortable: true, stickyColumn: true },
    { key: 'nombre', sortable: true },
    { key: 'aamm', label: 'Año y mes de inicio', sortable: true },
    { key: 'activo', label: 'Estatus', sortable: true },
  ]
  //* Params to fill table data & filters
  const configRequest = ref({
    wsParams: { action: 1, token: store.state.cuenta.session.token }, //* Request params
    wsType: 'wsplanEstudios', //* WebService name
    filterGetter: 'servicioEscolar/filterPlanes', //* Getter function to filter data
  })

  return { tableColumns, configRequest }
}

//* Make http request to get info by asignature's id
export const planInfo = idPlan => new Promise((resolve, reject) => {
  const paramsRequest = {
    action: 2,
    plan_estudios: idPlan,
    token: store.state.cuenta.session.token,
  }

  getData(paramsRequest, 'wsplanEstudios')
    .then(response => {
      if (response.status === 200 && response.data.status === 200) {
        resolve(response.data.data)
      } else reject(response.data.message)
    })
    .catch(err => { reject(err) })
})

//* Make http request to get all asignatures
export const especialidadesList = () => new Promise((resolve, reject) => {
  const paramsRequest = {
    action: 1,
    token: store.state.cuenta.session.token,
  }
  getData(paramsRequest, 'wsEspecialidades')
    .then(response => {
      if (response.status === 200 && response.data.status === 200) resolve(response.data.especialidades)
      else reject(response.data.message)
    })
    .catch(err => { reject(err) })
})

//* Make http request to get all temporalities
export const temporalitiesList = () => new Promise((resolve, reject) => {
  const paramsRequest = {
    action: 7,
    token: store.state.cuenta.session.token,
  }
  getData(paramsRequest, 'wsplanEstudios')
    .then(response => {
      if (response.status === 200 && response.data.status === 200) resolve(response.data.data)
      else reject(response.data.message)
    })
    .catch(err => { reject(err) })
})

//* Make http request to get all planteles
export const plantelList = () => new Promise((resolve, reject) => {
  const paramsRequest = {
    action: 8,
    token: store.state.cuenta.session.token,
  }
  getData(paramsRequest, 'wsplanEstudios')
    .then(response => {
      if (response.status === 200 && response.data.status === 200) resolve(response.data.data)
      else reject(response.data.message)
    })
    .catch(err => { reject(err) })
})
